@if (areMiniGamesEnabled) {
    <ds-card noOverflow msThemedCard [themeCardElevated]="themeElevated" [elevated]="true" [border]="true">
        <ds-accordion
            variant="transparent"
            msThemedAccordion
            [themedAccordionVariant]="themedAccordionVariant"
            [withCard]="true"
            [open]="!collapsed"
            (openedChange)="panelToggled()">
            <ds-accordion-header class="accordion-header-alignment">
                <div slot="start">
                    <div slot="title">{{ sitecore.globalMessages.MiniGames }}</div>
                </div>
                <span class="icon-alignment" *dsAccordionTrigger="let isOpen">
                    <vn-icon size="16" [name]="!isOpen ? 'theme-down' : 'theme-up'" />
                </span>
            </ds-accordion-header>
            <ng-template #content>
                <ms-minigames [hidden]="collapsed" />
            </ng-template>
        </ds-accordion>
    </ds-card>
}
